import { defer } from 'underscore';
import { pgridFactory } from '@bingads-webui-campaign/pgrid-factory';
import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import { updateGridQuery } from '@bingads-webui-campaign/summary-grid-helper';
import { createAuctionInsightPopupFactory } from '@bingads-webui-campaign/auction-insight-popup';
import { insightPopupContainerId, insertPopoverContainer } from '@bingads-webui-campaign/fluctuation-common';
import { levelAtConstant } from '@bingads-webui-campaign/scope-constants';

export class GeneralInsightsGrid extends DeterministicWrapperView {
  viewFactory({
    i18n,
    newI18n,
    serverContext,
    scope,
    instrumentation,
    filterService,
    getGridConfig,
    getPlugins,
    preferenceConfig,
    refreshChart,
  }) {
    this.grid = pgridFactory({
      gridConfig: getGridConfig(this),
      plugins: getPlugins(this),
      preferenceConfig,
    });
    this.filterService = filterService;
    this.refreshChart = refreshChart;
    this.gridRemoved = false;
    this.newI18n = newI18n;
    this.i18n = i18n;
    this.serverContext = serverContext;
    this.scope = scope;
    this.instrumentation = instrumentation;

    filterService.on('filter-state-changed', () => {
      if (!this.gridRemoved) {
        updateGridQuery(
          this.grid.gridView,
          this.filterService.getCombinedFilter(), true
        );
        defer(this.refreshChart);
      }
    });

    return this.grid.gridView;
  }

  renderTrunk() {
    this.filterService.initializeCombinedFilterPromise.then(() => {
      if (!this.gridRemoved) {
        updateGridQuery(
          this.grid.gridView,
          this.filterService.getCombinedFilter(), true
        );
        defer(this.refreshChart);
      }
    });
    super.renderTrunk();
  }

  remove() {
    this.gridRemoved = true;
    super.remove();
  }

  showInsightsPopup(event) {
    if (!this.scope.levelAt === levelAtConstant.CUSTOMER) { return; }
    const { currentTarget } = event;
    event.stopPropagation();
    insertPopoverContainer();
    const dateRange = this.grid.dateFilter.getCurrentDateRange();

    createAuctionInsightPopupFactory({
      triggerButton: currentTarget,
      i18n: this.newI18n,
      legacyI18n: this.i18n,
      context: this.serverContext,
      instrumentation: this.instrumentation,
      insightData: {
        startDate: dateRange.RangeStartDate,
        endDate: dateRange.RangeEndDate,
        metric: {
          name: this.newI18n.getString(_TL_('Impression share')),
          value: currentTarget.getAttribute('data-metric-value'),
        },
        domainNumber: currentTarget.getAttribute('data-item-index'),
        accountIds: this.scope.underPerformingAccountIds,
      },
      accountsInfo: this.scope.accountsInfo.items,
      onDismiss: () => {
        if (currentTarget) {
          currentTarget.focus();
        }
      },
    }, document.getElementById(insightPopupContainerId));
  }

  get className() { return 'general-insights-grid'; }

  get events() {
    return {
      'click .performance-metrics-insight .iconba': 'showInsightsPopup',
    };
  }
}
